import { smb_fetch, getAgsApiUrl } from '@/api/operator/fetch';

// 商机原因
export const getPotentialReason = (data: any = {}) => {
  const url = getAgsApiUrl('v2', 'potential-season-type');
  const params = $.extend(
    true,
    {
      method: 'GET',
      isCache: true,
    },
    data,
  );
  return smb_fetch(url, params, true, false);
};
